






















import {Component, Prop, Vue} from 'vue-property-decorator'
import {
  DxButton
} from 'devextreme-vue/ui/button';

@Component({
  name: 'DButton',
  components: {
    DxButton
  }
})
export default class extends Vue {

  @Prop({ default: () => {} }) public onClick!: Function;
  @Prop({default: 'success'}) public btnType!: string;
  @Prop({default: ''}) public btnText!: string;
  @Prop({default: 'contained'}) public stylingMode!: string;
  @Prop({default: ''}) public icon!: string;
  @Prop({default: false}) public disabled!: boolean;
  @Prop({default: false}) public useSubmiteBehavior!: boolean;
  @Prop({default: 'auto'}) public width!: string | number;
  @Prop({default: ''}) public cssClass!: string;
  @Prop({default: false}) public hidePadding!: boolean;
  @Prop({default: undefined}) public hint!: string;
  @Prop({default: '28px'}) public height!: string;
  @Prop({default: ''}) public elemStyle!: string;

  created() {

  }

}
